import type { HTMLAttributes } from 'react'
import { cn } from './cn'

type AvatarSize = 'sm' | 'md' | 'lg'
const sizes: Record<AvatarSize, string> = { sm: 'w-7 h-7 text-xs', md: 'w-9 h-9 text-sm', lg: 'w-14 h-14 text-base' }

export interface AvatarProps extends HTMLAttributes<HTMLSpanElement> {
  src?: string
  alt?: string
  initials?: string
  size?: AvatarSize
}

/** Avatar — image or initials, on the ink-soft chip. */
export function Avatar({ src, alt = '', initials, size = 'md', className = '', ...props }: AvatarProps) {
  return (
    <span
      className={cn('inline-grid place-items-center shrink-0 rounded-full overflow-hidden font-display font-medium bg-ink-soft text-on-ink ring-1 ring-veil-line', sizes[size], className)}
      {...props}
    >
      {src ? <img src={src} alt={alt} className="w-full h-full object-cover" /> : <span aria-hidden={!alt || undefined}>{initials}</span>}
    </span>
  )
}
